import React, { useState, useEffect } from 'react';
import Button from '../../../../shared/Button/Button';
import BonusPointsContainer from './BonusPointsContainer';
import { claimBonusPointsStyle as styles } from './claimBonusPoints.tailwind';
import { connect, useSelector } from 'react-redux';
// import Spinner from '../../../../shared/Loaders/Spinner';
import giftBox from '../../../../../assets/images/gift_box.png';
import { claimBonusPoint } from '../../../../../redux/slices/earnPointSlice';
import { BONUS_CLAIM_TYPE } from '../../../../../lib/constants/globalConstant';
import ConfirmBonusClaimModal from '../../../../shared/Modals/ConfirmBonusClaimModal/ConfirmBonusClaimModal';
import ClaimBonusSkeleton from '../../../shared/Skeletons/ClaimBonusSkeleton/ClaimBonusSkeleton';

const ClaimBonusPoints = ({ bonusPoint }) => {
  const { bonusPoints, bonusPointsLoading } = useSelector((state) => state.earnPoint);
  const { currentSeason } = useSelector(state => state.seasons);

  const [areAllClaimed, setAreAllClaimed] = useState(false);
  const [isClaimingAll, setIsClaimingAll] = useState(false);  // Track claim process for "Claim All"
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Check if all bonus points are claimed
  useEffect(() => {
    if (bonusPoints?.bonusPoints?.length > 0) {
      const allClaimed = bonusPoints?.bonusPoints?.every((bonus) => bonus?.isClaimed);
      setAreAllClaimed(allClaimed);
    }
  }, [bonusPoints]);

  const handleClaimAll = () => {
    setIsClaimingAll(true);  // Start claiming process
    bonusPoint({
      claimType: BONUS_CLAIM_TYPE.ALL,
      seasonId: currentSeason?._id
    }).finally(() => {
      setIsModalOpen(false);
      setIsClaimingAll(false)
    });  // End claiming process
  };

  return (
    <div className={styles.outerContainer}>
      <div className={styles.headerContainer}>
        <h1 className={styles.heading}>
          Claim bonus points
          {/* <div className={styles.dividerContainer}>
            <div className={`${styles.divider} w-[30px] md:w-[50px]`}></div>
            <div className={`${styles.divider} w-[10px] md:w-[30px]`}></div>
            <div className={`${styles.divider} w-[5px] md:w-[25px]`}></div>
          </div> */}
        </h1>

        {bonusPoints?.bonusPoints?.length > 0 && !bonusPointsLoading && !areAllClaimed && (
          <Button
            variant="text"
            className={`${styles.button} ${isClaimingAll || areAllClaimed ? 'bg-green-500' : 'bg-primary'}`}  // Change background color if claimed or claiming
            onClick={() => setIsModalOpen(true)}
            disabled={areAllClaimed || isClaimingAll}  // Disable if all claimed or if claiming
          >
            {isClaimingAll ? 'Claiming...' : areAllClaimed ? 'Claimed' : 'Claim All'}
          </Button>
        )}
      </div>

      {bonusPointsLoading ? (
        <div className={styles.componentContainer}>
          <ClaimBonusSkeleton />
        </div>
      ) : (
        <div className={styles.componentContainer}>
          {bonusPoints?.bonusPoints?.length > 0 ? (
            bonusPoints?.bonusPoints.map((bonusPoint) => (
              <BonusPointsContainer
                key={bonusPoint?._id}
                bonusPoint={bonusPoint}
              />
            ))
          ) : (
            <div className={styles.emptyContainer}>
              <img src={giftBox} alt="empty" className={styles.emptyImage} />
              <p className={styles.emptyText}>No bonus points available at the moment.</p>
            </div>
          )}
        </div>
      )}
      {isModalOpen && (
        <ConfirmBonusClaimModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onClaim={handleClaimAll} // Pass function
          bonusDetail={{
            bonusTitle: `All available bonuses`,
          }}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  bonusPoint: (data) => dispatch(claimBonusPoint(data)),
});

export default connect(null, mapDispatchToProps)(ClaimBonusPoints);
